// #357 change #3 — 50/80/100% usage nudges. Pure tier logic + the (default OFF) flag.
export type CreditNudgeTier = '50' | '80' | '100';

/**
 * Compile-time default, same pattern as PAIRING_CODE_ENABLED: flip to true in a release PR.
 * For staging QA without a rebuild: localStorage.btCreditNudges = '1' (read-only override to ON).
 */
export const CREDIT_NUDGES_ENABLED = false;

export function isCreditNudgesEnabled(): boolean {
  if (CREDIT_NUDGES_ENABLED) return true;
  try {
    return typeof localStorage !== 'undefined' && localStorage.getItem('btCreditNudges') === '1';
  } catch {
    return false;
  }
}

/** Which nudge (if any) the current usage warrants. 100 = out of credits. */
export function creditNudgeTier(percentageUsed: number, creditsRemaining: number): CreditNudgeTier | null {
  if (!Number.isFinite(percentageUsed) || !Number.isFinite(creditsRemaining)) return null;
  if (creditsRemaining <= 0) return '100';
  if (percentageUsed >= 80) return '80';
  if (percentageUsed >= 50) return '50';
  return null;
}

/** Only the soft 50% tier can be dismissed (per browser session, per cycle-tier). 80/100 stay. */
export const NUDGE_DISMISS_KEY = 'btCreditNudge50Dismissed';

export function isNudgeDismissed(): boolean {
  try { return typeof sessionStorage !== 'undefined' && sessionStorage.getItem(NUDGE_DISMISS_KEY) === '1'; } catch { return false; }
}
export function dismissNudge(): void {
  try { sessionStorage.setItem(NUDGE_DISMISS_KEY, '1'); } catch { /* per-viewer convenience only */ }
}
